export const SCREEN = {
  EMPTY: '',
  APP: 'app',
  HOME: 'home',
  ADMIN: 'admin',
  AGENT: 'agent',
  ADMINISTRATION: 'administration',
  MARKETING: 'marketing',
  GARAGE: 'garage',
  GARAGE_PRODUCT: 'garage_product',
  CORPORATE: 'corporate',
  CORPORATE_USER: 'corporate_user',
  USER: 'user',
  USERS: 'users',
  LOGIN: 'login',
  INFO: 'info',
  FAQ: 'faq',
  RULES: 'rules',
  INSTRUCTIONS: 'instructions',
  MAP: 'map',
  LIST: 'list',
  FAVORITES: 'favorites',
  HISTORY: 'history',
  DEPOSIT: 'deposit',
  MONITORING: 'monitoring',
  REPORTS: 'reports',
  RECON: 'recon',
  POINTS: 'points',
  POINT: 'point',
  ACCESS: 'access',
  BRANDS: 'brands',
  BRAND: 'brand',
  PROFILE: 'profile',
  PROFILE_EDIT: 'profile_edit',
  PROMOCODE: 'promocode',
  DETAILS: 'details',
  STATUS: 'status',
  PAYMENT: 'payment',
  ACCOUNT_DEBIT: 'debit',
  ACCOUNT_DEBIT_ADD: 'debit/add',
  NOTIFICATIONS: 'notifications',
  MARKET: 'market',
  PROFILE_MARKET: 'profile_market',
  PROFILE_OSAGO: 'profile_osago',
  MARKET_PROFILE: 'market/profile',
  MARKET_FAVORITES: 'market/favorites',
  PRODUCTS: 'products',
  PRODUCT: 'product',
  PRODUCT_ADD: 'product/add',
  PARTNER: 'partner',
  OSAGO: 'osago',
} as const
